import api from "@/api";
import { AxiosResponse } from "axios";
import User from "@/types/User";

async function getUserData(): Promise<AxiosResponse<User>> {
  return await api.get<User>("/api/user");
}

export default getUserData;
